import { render, staticRenderFns } from "./AddMaster.vue?vue&type=template&id=ae20b61a"
import script from "./AddMaster.vue?vue&type=script&lang=js"
export * from "./AddMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports